import React from 'react';
import { Container } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Trans } from 'react-i18next';

const OutsourcingPilar10 = props => (
    <section id="outsourcing-pilar-section10" className="my pt-5 white-bg">
        <div className='black-shape'></div>
        <Container>
            <div className="title-triangle top-md fw-600"></div>
            <h2 className="h4 black fw-600 mb-5">{props.t('services:outsourcingPilar:section-10.title')}</h2>
            <p className='mb-5'><Trans>{props.t('services:outsourcingPilar:section-10.text')}</Trans></p>
            {/* Text content */}
            <div className='mb-5'>
                <div className='d-flex align-items-center mb-4'>
                    <div className='arrow-container'>
                        <div className='arrow'>
                            <FontAwesomeIcon icon={['fas', 'arrow-right']} />
                        </div>
                    </div>
                    <h3 className='h5 fw-600 m-0'>{props.t('services:outsourcingPilar:section-10.1.title')}</h3>
                </div>
                <p className='m-0'><Trans>{props.t('services:outsourcingPilar:section-10.1.text')}</Trans></p>
            </div>
            {/* Text content */}
            <div>
                <div className='d-flex align-items-center mb-4'>
                    <div className='arrow-container'>
                        <div className='arrow'>
                            <FontAwesomeIcon icon={['fas', 'arrow-right']} />
                        </div>
                    </div>
                    <h3 className='h5 fw-600 m-0'>{props.t('services:outsourcingPilar:section-10.2.title')}</h3>
                </div>
                <p className='mb-5'><Trans>{props.t('services:outsourcingPilar:section-10.2.text')}</Trans></p>
            </div>
            {/* Text content */}
            <div>
                <div className='d-flex align-items-center mb-4'>
                    <div className='arrow-container'>
                        <div className='arrow'>
                            <FontAwesomeIcon icon={['fas', 'arrow-right']} />
                        </div>
                    </div>
                    <h3 className='h5 fw-600 m-0'>{props.t('services:outsourcingPilar:section-10.3.title')}</h3>
                </div>
                <p className='m-0'><Trans>{props.t('services:outsourcingPilar:section-10.3.text')}</Trans></p>
            </div>
        </Container>
    </section>
);


export default OutsourcingPilar10;